const generateRandomString = (length = 3) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

const removeEverythingAfter = (str: string, keyString: string, fromWord: 'start' | 'end') => {
  const removeAfter = str.indexOf(keyString) + (fromWord === 'start' ? 0 : keyString.length);
  return str.substring(0, removeAfter);
};

export {
  generateRandomString,
  removeEverythingAfter,
};
